/**
 *
 * Asynchronously loads the component for Box2Chart
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Box2Chart = lazyLoad(
  () => import('./index'),
  module => module.Box2Chart,
);
